import { CSSProperties, PropsWithChildren, useMemo } from "react";

interface SpacerProps {
  top?: number;
  left?: number;
  right?: number;
  bottom?: number;
}

const Spacing = ({
  top,
  left,
  right,
  bottom,
  children,
}: PropsWithChildren<SpacerProps>) => {
  const style = useMemo(() => {
    const properties: CSSProperties = {};
    const spacing1x = "var(--spacing)";
    if (top) properties.marginTop = top === 1 ? spacing1x : `var(--spacing-${top}x)`;
    if (left) properties.marginLeft = left === 1 ? spacing1x : `var(--spacing-${left}x)`;
    if (right)
      properties.marginRight = right === 1 ? spacing1x : `var(--spacing-${right}x)`;
    if (bottom)
      properties.marginBottom = bottom === 1 ? spacing1x : `var(--spacing-${bottom}x)`;
    return properties;
  }, [top, left, right, bottom]);

  return <div style={style}>{children}</div>;
};

export default Spacing;
